'use es6';

import { render } from 'react-dom';
import { Provider } from 'react-redux';
import Raven from 'raven-js';
import staticAdapter from 'react-rhumb/staticAdapter';
import { ThemeProvider } from 'styled-components';
import { RhumbProvider } from 'react-rhumb';
import rhumbConfig from '../rhumb-config.yaml';
import { isAuthedAppPreview, isIframed, tryLocalStorageGet } from 'video-embed/utils/env';
import { LOCALSTORAGE_DEBUG_KEY } from 'video-embed/utils/debug';
import { getAuth } from './actions/auth';
import PlayerError from './components/PlayerError';
import PlayerApp from './containers/PlayerApp';
import theme from './theme';
import configureStore from './utils/configureStore';
import { loadInAppPreviewI18n, loadPublicI18n } from './utils/I18n';
import { jsx as _jsx } from "react/jsx-runtime";
export default class Application {
  constructor() {
    this.renderInvalidUrl = () => {
      render( /*#__PURE__*/_jsx(PlayerError, {
        videoFetchError: {
          status: 404
        },
        hasPlaybackStarted: false
      }), document.querySelector('.page'));
    };
    this.renderApp = () => {
      const truthyPathParts = window.location.pathname.split('/').filter(part => part);
      const debugFlagEnabled = tryLocalStorageGet(LOCALSTORAGE_DEBUG_KEY) === 'true';

      // do not load unless we have the expected videoId, preventing react-rhumb unexpected route errors
      if (truthyPathParts.length < 4) {
        this.renderInvalidUrl();
        return;
      }
      const defaultEmbedId = isIframed() ? 'unknown' : 'direct-view';
      render( /*#__PURE__*/_jsx(RhumbProvider, {
        config: rhumbConfig,
        history: staticAdapter('/id/:videoId'),
        children: /*#__PURE__*/_jsx(Provider, {
          store: this.store,
          children: /*#__PURE__*/_jsx(ThemeProvider, {
            theme: theme,
            children: /*#__PURE__*/_jsx(PlayerApp, {
              tracker: this.tracker,
              params: this.params,
              portalId: this.params.portalId,
              embedId: this.params.embedId || defaultEmbedId,
              debugFlagEnabled: debugFlagEnabled
            })
          })
        })
      }), document.querySelector('.page'));
    };
  }
  start(params, tracker) {
    this.params = params;
    this.tracker = tracker;
    this.store = configureStore({
      params
    });
    const userInfoMaybe = isAuthedAppPreview() ? this.store.dispatch(getAuth()) : Promise.resolve();
    userInfoMaybe.then(auth => auth ? loadInAppPreviewI18n(auth) : loadPublicI18n(params.locale)).then(this.renderApp).catch(err => {
      console.error('Fatal error in Application.start', err);
      Raven.captureException(err, {
        fingerprint: ['Application.start']
      });
    });
  }
}